import React from 'react';
import { Sparkles } from 'lucide-react';
import { ABLE_COLORS } from '../../constants';

/**
 * GuidancePrompt - Compact Mabel chat entry point card
 *
 * Matches the style of Tasks/Kitchen cards.
 * Clicking opens the chat interface.
 */
export default function GuidancePrompt({
  onOpenChat
}) {
  return (
    <button
      onClick={onOpenChat}
      style={{
        padding: '16px 12px',
        background: ABLE_COLORS.neutral,
        border: 'none',
        borderRadius: ABLE_COLORS.cardRadius,
        boxShadow: ABLE_COLORS.cardShadow,
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '6px',
        transition: 'all 0.15s ease',
        width: '100%'
      }}
    >
      <div style={{
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        background: `linear-gradient(135deg, ${ABLE_COLORS.primary} 0%, ${ABLE_COLORS.secondary} 100%)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <Sparkles size={14} color="white" />
      </div>
      <span style={{
        fontSize: '13px',
        fontWeight: '600',
        color: ABLE_COLORS.textPrimary
      }}>
        Ask Mabel
      </span>
      <span style={{
        fontSize: '10px',
        color: ABLE_COLORS.textMuted
      }}>
        I'm here to help
      </span>
    </button>
  );
}
